import {
  CheckCircle,
  InfoOutlined,
  LockOutlined,
  WarningRounded,
  WifiOutlined,
} from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { LinearLoader } from "../";
import { useEffect, useState } from "react";

const styles = () => {
  return {
    "& .button-footer": {
      mt: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    "& .no-wifi": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .warning-icon": {
        color: "#F9B426",
        marginRight: "12px",
        fontSize: "40px",
      },
    },
    "& .footer-section": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      pt: 4,
    },
    "& .wifi-list": {
      height: "400px",
      overflowY: "scroll",
    },
    "& .wifi-item": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 0.5,
      py: 1,
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#004057",
        color: "white",
        borderRadius: "4px",
      },
      "& .icons-section": {
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
        "& .MuiSvgIcon-root": {
          marginLeft: "12px",
        },
      },
    },
  };
};

const SelectWifiNetwork = ({
  loading,
  list,
  networkSettings,
  onClickSelectWifiNetwork,
  onCancel,
  onClickSearch,
}) => {
  const [connected, setConnected] = useState({});

  useEffect(() => {
    if (list.length > 0 && networkSettings) {
      const item = list.find(
        (it) => it?.ssid === networkSettings.settings?.wifi?.ssid
      );
      if (item) {
        setConnected(item);
      }
    }
  }, [list, networkSettings]);

  return (
    <Box sx={styles}>
      {loading && <LinearLoader message="Searching..." />}
      {!loading && (
        <Box>
          {list.length > 0 && (
            <Box className="wifi-list">
              {connected && (connected?.ssid || connected?.bssid) && (
                <Box>
                  <Typography variant="subtitle1" mb={0.5}>
                    Connected
                  </Typography>
                  <Box className="wifi-item">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <CheckCircle color="success" />
                      <Typography ml={1.5} variant="body1">
                        {connected.ssid || connected.bssid}
                      </Typography>
                    </Box>
                    <Box className="icons-section">
                      {connected.secured && <LockOutlined />}
                      <WifiOutlined />
                      <InfoOutlined />
                    </Box>
                  </Box>
                </Box>
              )}
              <Box>
                <Typography variant="subtitle1" my={1}>
                  Network
                </Typography>
                {list.map((item, i) => (
                  <Box
                    key={i}
                    className="wifi-item"
                    onClick={() => onClickSelectWifiNetwork(item)}
                  >
                    <Box ml={4}>
                      <Typography variant="body1">
                        {item.ssid || item.bssid}
                      </Typography>
                    </Box>
                    <Box className="icons-section">
                      {item.secured && <LockOutlined />}
                      <WifiOutlined />
                      <InfoOutlined />
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
          {list.length === 0 && (
            <Box className="no-wifi">
              <WarningRounded className="warning-icon" />
              <Typography variant="h4">No WiFi Networks Found</Typography>
            </Box>
          )}
          <Box className="footer-section">
            <Typography>WiFi network not found?</Typography>
            <Button
              onClick={() =>
                onClickSelectWifiNetwork({
                  ssid: "enterDetails",
                })
              }
            >
              ENTER DETAILS
            </Button>
          </Box>
        </Box>
      )}
      <Box className="button-footer">
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onClickSearch}>Search</Button>
      </Box>
    </Box>
  );
};

export default SelectWifiNetwork;
